// Test environment variable access in browser
console.log('🧪 COGNITO CONFIGURATION TEST');
console.log('==============================');

// Test all environment variable access methods
console.log('📋 Testing environment variable access methods:');

// Method 1: process.env
console.log('1. process.env test:');
console.log('   - typeof process:', typeof process);
console.log('   - process.env exists:', !!(typeof process !== 'undefined' && process.env));
if (typeof process !== 'undefined' && process.env) {
  console.log('   - REACT_APP_COGNITO_USER_POOL_ID:', process.env.REACT_APP_COGNITO_USER_POOL_ID || 'UNDEFINED');
  console.log('   - REACT_APP_COGNITO_CLIENT_ID:', process.env.REACT_APP_COGNITO_CLIENT_ID || 'UNDEFINED');
  console.log('   - REACT_APP_COGNITO_DOMAIN:', process.env.REACT_APP_COGNITO_DOMAIN || 'UNDEFINED');
}

// Method 2: window.env
console.log('2. window.env test:');
console.log('   - typeof window:', typeof window);
console.log('   - window.env exists:', !!(typeof window !== 'undefined' && window.env));
if (typeof window !== 'undefined' && window.env) {
  console.log('   - REACT_APP_COGNITO_USER_POOL_ID:', window.env.REACT_APP_COGNITO_USER_POOL_ID || 'UNDEFINED');
}

// Method 3: Check if variables are hardcoded as fallback
const fallbackConfig = {
  userPoolId: 'eu-west-1_XTXemZYOB',
  clientId: '10198m3o5no6869nupme2hohrb',
  domain: 'https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_XTXemZYOB'
};

console.log('3. Fallback configuration available:', fallbackConfig);

export default {
  fallbackConfig,
  testEnvironmentAccess: () => {
    console.log('🔍 Environment variable test completed - check console output above');
  }
}; 